import { ColumnConfiguration } from 'src/common/components/ConfigurableTable/models/configurableTable';
import { getI18n } from 'react-i18next';
import { parseMNOStatusToDisplayValue } from 'src/common/components/Sim/Inventory/utils/simListResponseParsers';
import { MNOStatus } from 'src/common/components/Sim/constants/mnoStatus';
import { parseResponseDateAndTime } from 'src/common/utils/parseResponseDate';

const i18n = getI18n();

export type ESimProfileDTO = {
  iccid: string;
  imsi: string | null;
  msisdn: string | null;
  mobileNetworkOperator: string | null;
  customerCommsPlan: string | null;
  mnoStatus: MNOStatus | null;
  enabled: boolean;
  mnoStatusEntryTime: string | null;
  managementIpAddress: string | null;
  currentIpAddress: string | null;
  ccii: string | null;
  commsPlan: string | null;
  mnoRatePlan: string | null;
};

export type ESimProfilesDTO = {
  eid: string;
  profilesInfo: ESimProfileDTO[];
};

export type ESimProfile = ESimProfileDTO & {
  esimEid: string;
};

export const ESIM_PROFILES_CONFIGURATION: ColumnConfiguration[] = [
  {
    field: 'iccid',
    headerName: i18n.t('common.iccid'),
    resizable: false,
    sortable: false,
    pinnable: false,
    minWidth: 180,
  },
  {
    field: 'enabled',
    headerName: i18n.t('simInventory.profileStatus'),
    resizable: false,
    sortable: false,
    pinnable: false,
    minWidth: 128,
  },
  {
    field: 'imsi',
    headerName: i18n.t('common.imsi'),
    resizable: false,
    sortable: false,
    pinnable: false,
    minWidth: 180,
  },
  {
    field: 'msisdn',
    headerName: i18n.t('common.msisdn'),
    resizable: false,
    sortable: false,
    pinnable: false,
    minWidth: 180,
  },
  {
    field: 'mnoStatus',
    headerName: i18n.t('common.mnoStatus'),
    resizable: false,
    sortable: false,
    pinnable: false,
    minWidth: 150,
    valueGetter: (mnoStatus: MNOStatus) => parseMNOStatusToDisplayValue(mnoStatus),
    subField: {
      field: 'mnoStatusEntryTime',
      headerName: i18n.t('simInventory.mnoStatusEntryTime_combined'),
      sortable: false,
      valueGetter: (mnoStatusEntryTime: string) => parseResponseDateAndTime(mnoStatusEntryTime),
    },
  },
  {
    field: 'commsPlan',
    headerName: i18n.t('simInventory.commsPlan'),
    resizable: false,
    sortable: false,
    pinnable: false,
    minWidth: 240,
  },
  {
    field: 'mobileNetworkOperator',
    headerName: i18n.t('simInventory.mobileNetworkOperator'),
    resizable: false,
    sortable: false,
    pinnable: false,
    minWidth: 240,
  },
  {
    field: 'mnoRatePlan',
    headerName: i18n.t('simInventory.mnoRatePlan'),
    resizable: false,
    sortable: false,
    pinnable: false,
    minWidth: 240,
  },
];
